import { Message, MessageConnection } from '../../models/chat.models';

export class LoadMessages {
    static readonly type = '[Message] Load Messages';
    constructor(
        public channelId: string,
        public limit?: number,
        public nextToken?: string,
    ) {}
}

export class LoadMessagesSuccess {
    static readonly type = '[Message] Load Messages Success';
    constructor(
        public channelId: string,
        public connection: MessageConnection,
        public requestNextToken?: string,
    ) {}
}

export class LoadMessagesError {
    static readonly type = '[Message] Load Messages Error';
    constructor(
        public channelId: string,
        public error: any,
    ) {}
}

// Load More (pagination)
export class LoadMoreMessages {
    static readonly type = '[Message] Load More Messages';
    constructor(
        public channelId: string,
        public limit?: number,
    ) {}
}

export class LoadMoreMessagesSuccess {
    static readonly type = '[Message] Load More Messages Success';
    constructor(
        public channelId: string,
        public connection: MessageConnection,
        public requestNextToken?: string,
    ) {}
}

export class LoadMoreMessagesError {
    static readonly type = '[Message] Load More Messages Error';
    constructor(
        public channelId: string,
        public error: any,
    ) {}
}

export class SendMessage {
    static readonly type = '[Message] Send Message';
    constructor(
        public channelId: string,
        public content?: string,
        public files?: string[],
        public isFromBot?: boolean,
    ) {}
}
export class SendMessageSuccess {
    static readonly type = '[Message] Send Message Success';
    constructor(
        public channelId: string,
        public message: Message,
        public optimisticId?: string,
    ) {}
}
export class SendMessageError {
    static readonly type = '[Message] Send Message Error';
    constructor(
        public channelId: string,
        public error: any,
        public optimisticId?: string,
    ) {}
}

// Utility Actions
export class ClearMessagesForChannel {
    static readonly type = '[Message] Clear Messages For Channel';
    constructor(public channelId: string) {}
}

export class AddMessage {
    static readonly type = '[Message] Add Message';
    constructor(
        public channelId: string,
        public message: Message,
    ) {}
}
